import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { getSitesByDcIdSelectQueryOptions } from '@/features/sites/query-options'
import { fetchTour } from '@/features/tours/api'

import { tourParamsSchema } from '../-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/tours/$tourId'
)({
  parseParams: (params) => parse(tourParamsSchema, params),
  loader: async ({
    abortController,
    params: { tourId, tenantKey },
    context: { auth, queryClient }
  }) => {
    const tour = await fetchTour(
      {
        tenantKey,
        tourId
      },
      abortController.signal
    )
    const sites = await queryClient.ensureQueryData(
      getSitesByDcIdSelectQueryOptions({
        tenantKey,
        dcId: tour.dc.id
      })
    )
    return {
      authUser: auth.user,
      tour,
      sites
    }
  },
  meta: ({ loaderData }) => [
    {
      title: `${loaderData.tour.dc.name} : ${loaderData.tour.dailyReportNo}`
    }
  ]
})
